export const CONST = {

  // BACKEND_URL: 'https://172.105.62.213/api/v1',
  // BACKEND_EMPROLE_URL: 'https://172.105.62.213/api/v1/emprole',
  // BACKEND_SURVEY_URL: 'https://172.105.62.213/api/survey',
  // SURVEY_URL: 'https://172.105.62.213/surveylink/#/v2/',
  // IMAGES_URL: 'https://172.105.62.213/images/',

  BACKEND_URL: 'https://insightplus.happyplus.in/api/v1',
  BACKEND_EMPROLE_URL: 'https://insightplus.happyplus.in/api/v1/emprole',
  BACKEND_SURVEY_URL: 'https://insightplus.happyplus.in/api/survey',
  SURVEY_URL: 'https://insightplus.happyplus.in/surveylink/#/v2/',
  IMAGES_URL: 'https://insightplus.happyplus.in/images/',


  // IMAGES_URL: '/assessment_images/',
  // BACKEND_URL: 'https://demoplus.happyplus.in/api/v1',

  APP_NAME: 'Insight Plus',
  FOOTER_TEXT: '© 2026 Insight Plus. All rights reserved.',
};
